import styled from '@emotion/styled';

import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Trash from '@/images/Trash.svg';
import { useTheme } from '@mui/material';
import { useQueryClient } from 'react-query';
import { deleteConsent } from '../../api';
import { GET_CONSENTS_KEY } from '../../hooks';

const StyledIconButton = styled(IconButton)`
    position: absolute;
    background-color: white;
    top: 8px;
    right: 8px;
    padding: 6px;
    z-index: 2;

    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 8px;

    :hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
        border: 1px solid ${({ theme }) => theme.colors.black[300]};
        border-radius: 8px;
    }
`;

interface ConsentDeleteProps {
    id: string;
}

export const ConsentDelete = ({ id }: ConsentDeleteProps) => {
    const theme = useTheme();
    const queryClient = useQueryClient();

    const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        await deleteConsent(id);
        await queryClient.invalidateQueries(GET_CONSENTS_KEY);
    };

    return (
        <StyledIconButton ariaLabel="delete consent" onClick={handleClick}>
            <MaskedIcon src={Trash} size="18px" color={theme.colors.secondary[900]} />
        </StyledIconButton>
    );
};
